import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/auth`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/forgot-password`, { email: email.trim() });
    } catch {
      // Always show success – no enumeration
    }
    setBusy(false);
    setSent(true);
  };

  return (
    <div className="min-h-screen bg-cream-50 flex items-center justify-center px-6">
      <div className="w-full max-w-md" data-testid="forgot-password-card">
        <Link to="/campus/login" className="text-[12px] uppercase tracking-[0.32em] font-medium text-sand-500 mb-10 block">
          ← Anmelden
        </Link>

        {!sent ? (
          <>
            <h1 className="font-display text-sand-800 text-3xl font-semibold leading-tight">
              Passwort vergessen?
            </h1>
            <p className="mt-2 text-sand-600 text-[14.5px]">
              Wir senden dir einen Link zum Zurücksetzen — gültig für 60&nbsp;Minuten.
            </p>

            <form onSubmit={submit} className="mt-10 grid gap-4" data-testid="forgot-password-form">
              <div>
                <label className="text-[11px] uppercase tracking-[0.22em] font-semibold text-sand-500 mb-2 block">
                  E-Mail
                </label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-password-email"
                  className="w-full rounded-xl border border-cream-300 bg-white px-4 h-12 text-[15px] outline-none focus:border-sand-800 transition-colors"
                />
              </div>

              <Button
                type="submit"
                disabled={busy}
                data-testid="forgot-password-submit"
                className="rounded-full bg-sand-800 hover:bg-sand-700 text-cream-50 h-12 px-6 text-[14.5px] font-medium mt-2 disabled:opacity-60"
              >
                <span className="inline-flex items-center gap-2">
                  {busy ? "Senden…" : "Link senden"}
                  {!busy && <ArrowRight className="h-4 w-4" strokeWidth={1.6} />}
                </span>
              </Button>
            </form>
          </>
        ) : (
          <div data-testid="forgot-password-sent">
            <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-terra/10 text-terra">
              <CheckCircle2 className="h-7 w-7" strokeWidth={1.6} />
            </div>
            <h1 className="font-display text-sand-800 text-3xl font-semibold mt-6 leading-tight">
              E-Mail unterwegs.
            </h1>
            <p className="mt-3 text-sand-600 text-[14.5px] leading-relaxed">
              Falls ein Konto zu <strong className="text-sand-800">{email}</strong> existiert,
              haben wir einen Link zum Zurücksetzen verschickt.<br /><br />
              Schau in dein Postfach (auch Spam) — der Link ist 60&nbsp;Minuten gültig.
            </p>
            <Link
              to="/campus/login"
              className="inline-flex items-center gap-2 mt-8 rounded-full bg-sand-800 hover:bg-sand-700 text-cream-50 h-12 px-6 text-[14.5px] font-medium"
            >
              Zurück zur Anmeldung →
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
